<template>
  <div class="orders">
    <div class="orders-toolbar">
      <label class="h4 font-weight-bolder mr-5">Dealer Orders</label>
      <b-form-select class="orders-toolbar-sortby mr-1" v-model="sortby" :options="options" />
      <b-input-group class="orders-toolbar-search mr-1" prepend="search">
        <b-form-input v-model="search"></b-form-input>
      </b-input-group>
    </div>
    <div class="orders-list border-top">
      <order class="orders-list-card" v-for="(o,i) in orders" :key="i" :orderno="o.order_number"></order>
      <div
        class="orders-paging-buttons p-4 w-100 d-flex flex-row justify-content-between"
        style="max-width:45em;"
      >
        <b-button variant="primary" @click="prevPage()">Prev</b-button>
        <b-button variant="primary" @click="nextPage()">Next</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Order from "@/components/Order";

export default {
  components: {
    Order
  },
  mounted() {
    this.$orderService.getPage();
  },
  data() {
    return {
      selected: "cards",
      sortby: "order_number",
      search: "",
      pageNumber: 0,
      pageAmount: 50,
      options: [
        { text: "Order Number", value: "order_number" },
        { text: "Date", value: "date" },
        { text: "Customer Name", value: "customer_name" }
      ]
    };
  },
  methods: {
    nextPage() {
      let orderCount = this.$store.state.orders.length;
      let totalPages = Math.floor(orderCount / this.$data.pageAmount);
      this.$data.pageNumber =
        this.$data.pageNumber >= totalPages
          ? this.$data.pageNumber
          : this.$data.pageNumber + 1;
    },
    prevPage() {
      this.$data.pageNumber =
        this.$data.pageNumber == 0
          ? this.$data.pageNumber
          : this.$data.pageNumber - 1;
    }
  },
  computed: {
    orders() {
      let orderCount = this.$store.state.orders.length;
      let firstIndex = this.$data.pageNumber * this.$data.pageAmount;
      let ordersInPage =
        orderCount - firstIndex > this.$data.pageAmount
          ? this.$data.pageAmount
          : orderCount - firstIndex;
      let lastIndex =
        this.$data.pageNumber * this.$data.pageAmount + ordersInPage;
      let sortby = this.$data.sortby;
      return this.$store.state.orders
        .sort((a, b) => {
          let aClean = a[sortby];
          let bClean = b[sortby];
          if (sortby == "name" || sortby == "email") {
            aClean = aClean.toUpperCase();
            bClean = bClean.toUpperCase();
          }

          if (aClean > bClean) return -1;
          else if (aClean < bClean) return 1;
          else return 0;
        })
        .filter(o => {
          let filterQuery = String(o[sortby]);
          return filterQuery
            .toUpperCase()
            .includes(this.$data.search.toUpperCase());
        })
        .slice(firstIndex, lastIndex);
    }
  }
};
</script>

<style lang="scss" scoped>
.orders {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;

  &-toolbar {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    margin: 1.5em;
    &-sortby {
      width: 12em;
    }
    &-search {
      width: 20em;
    }
  }

  &-list {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;

    overflow-y: auto;
  }

  &-list-card {
    margin: 0.5em;
  }
}
</style>
